<template>
  <div class="navigation-menu">
    <router-link class="navigation-menu__logo" to="">
      <span class="navigation-menu__logo-btn">
        <v-icon color="white">$homeVariant</v-icon>
      </span>
      <span class="navigation-menu__logo-label">SmartHome</span>
    </router-link>
    <v-list dense class="navigation-menu__menu">
      <template
              v-for="(item, key) in getItems"
      >
        <v-list-item
                :key="key"
                link
                :to="item.to"
                class="navigation-menu__item"
                :class="{'v-list-item--active': item.active}"
        >
          <v-list-item-action>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template
                v-if="!!item.items && item.active"
        >
          <v-list-item
                  v-for="(subItem, subKey) in item.items"
                  :key="key + '' + subKey"
                  link
                  :to="subItem.to"
                  class="navigation-menu__item navigation-menu__item_sub"
          >
            <v-list-item-action>
              <v-icon color="white">{{ subItem.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t(subItem.text) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        items: [
          {icon: '$cctv', text: 'msg.videoMonitoring', to: {name: 'video'}}
        ]
      }
    },
    computed: {
      getItems() {
        this.items.forEach((item, key) => {
          if (item.items === undefined) return;
          for (let subKey in item.items) {
            this.items[key].active = item.items[subKey].to.name === this.$route.name;
            if (this.items[key].active) break;
            for (let _key in item.items[subKey].actions) {
              if (item.items[subKey].actions[_key] === this.$route.name) {
                this.items[key].active = true;
                break;
              }
            }
            if (this.items[key].active) break;
          }
        });
        return this.items;
      }
    }
  }
</script>

<style lang="scss">
  .navigation-menu {
    padding: 22px 14px;

    .navigation-menu__logo {
      color: #fff !important;
      font-size: 19px;
      font-weight: 700;
      letter-spacing: .2px;
      display: flex;
      align-items: center;
      padding: 0 10px 22px;
      border-bottom: 1px solid rgba(255, 255, 255, .1);
      text-decoration: none;

      .navigation-menu__logo-btn {
        width: 38px;
        height: 38px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        background: linear-gradient(135deg, #14b8a6, #0f766e);
        box-shadow: 0 8px 20px rgba(20, 184, 166, .24);

        .v-icon {
          font-size: 21px;
        }
      }
      .navigation-menu__logo-label {
        margin-left: 10px;
      }
    }
    .navigation-menu__menu {
      margin-top: 16px;
      padding: 0;
    }
    .v-list-item__title {
      color: #fff;
      font-size: 14px;
      font-weight: 500 !important;
    }
    .v-list-item__action {
      margin-right: 15px !important;
    }
    .navigation-menu__item {
      min-height: 48px;
      margin-top: 6px;
      padding: 0 12px;
      border-radius: 12px;
      color: rgba(255, 255, 255, .76);
      transition: background-color .2s ease, transform .2s ease;

      &:hover {
        background-color: rgba(255, 255, 255, .08);
        transform: translateX(2px);
      }
      &.navigation-menu__item_sub {
        min-height: 30px;

        &.v-list-item--active {
          background-color: rgba(76, 175, 80, 0.56) !important;
        }
      }
    }
    .v-list-item--active {
      background: linear-gradient(135deg, rgba(20, 184, 166, .95), rgba(15, 118, 110, .95)) !important;
      box-shadow: 0 8px 22px rgba(15, 118, 110, .25);
    }
  }
</style>
